import { Component, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastService, NotificationsService } from 'core/services';

@Component({
  selector: 'lms-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit, OnDestroy {
  private listeners = new Map<string, EventListener>();

  constructor(
    private el: ElementRef,
    private translateService: TranslateService,
    private toastService: ToastService,
    private notificationsService: NotificationsService
  ) {}

  ngOnInit() {
    this.on('langChanged', (e: any) => {
      const { lang } = e.detail || {};
      if (lang) {
        this.translateService.use(lang);
        localStorage.setItem('backofficelanguage', lang);
        location.reload();
      }
    });

    this.on('adminInviteResent', (e: any) => {
      const { admin } = e.detail || {};
      if (admin) {
        this.notificationsService.sendWelcomeAdminNotification(admin);
        this.toastService.showOk('', 2000, false);
      }
    });
  }

  ngOnDestroy() {
    this.listeners.forEach((fn, name) => this.el.nativeElement.removeEventListener(name, fn));
    this.listeners.clear();
  }

  private on(event: string, handler: EventListener) {
    if (this.listeners.has(event)) {
      this.el.nativeElement.removeEventListener(event, this.listeners.get(event));
    }
    this.el.nativeElement.addEventListener(event, handler);
    this.listeners.set(event, handler);
  }
}
